<template>
  <el-dialog
    :visible.sync="innerVisible"
    append-to-body
    custom-class="order-mode-required-dialog"
    :show-close="false"
    width="480px"
    @close="handleClose"
  >
    <div class="order-mode-required-dialog__header">
      <!-- 提示 -->
      <span class="order-mode-required-dialog__title">{{ $fanyi("提示") }}</span>
      <button
        type="button"
        class="order-mode-required-dialog__close"
        :aria-label="$fanyi('关闭')"
        @click="closeDialog"
      >
        <i class="el-icon-close"></i>
      </button>
    </div>
    <div class="order-mode-required-dialog__body">
      <!-- 请选择后续订单模式！ -->
      <p class="order-mode-required-dialog__main">
        {{ $fanyi("请选择后续订单模式！") }}
      </p>
      <!-- 选择完成后，后续可以在进口方资料界面修改默认订单模式！ -->
      <p class="order-mode-required-dialog__sub">
        {{
          $fanyi(
            "选择完成后，后续可以在进口方资料界面修改默认订单模式！"
          )
        }}
      </p>
    </div>
    <div class="order-mode-required-dialog__footer">
      <!-- 普通模式 -->
      <button
        type="button"
        class="order-mode-required-dialog__btn order-mode-required-dialog__btn--standard"
        @click="confirmMode(2)"
      >
        {{ $fanyi("普通模式") }}
      </button>
      <!-- DAP自税 -->
      <button
        type="button"
        class="order-mode-required-dialog__btn order-mode-required-dialog__btn--dap"
        @click="confirmMode(1)"
      >
        {{ $fanyi("DAP自税") }}
      </button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "OrderModeRequiredDialog",
  data() {
    return {
      innerVisible: false,
      // 用户选择模式后的回调
      onSelectMode: null,
    };
  },
  methods: {
    /**
     * 打开订单模式必选弹窗
     * @param {Function} onSelectMode 选择模式后回调，参数为 1|2
     */
    open(onSelectMode) {
      this.onSelectMode = onSelectMode;
      this.innerVisible = true;
    },
    // 确认选择订单模式
    confirmMode(mode) {
      this.innerVisible = false;
      if (typeof this.onSelectMode === "function") {
        this.onSelectMode(mode);
      }
      this.onSelectMode = null;
    },
    // 关闭弹窗
    closeDialog() {
      this.innerVisible = false;
      this.onSelectMode = null;
    },
    handleClose() {
      this.onSelectMode = null;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.order-mode-required-dialog {
  border-radius: 16px;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.order-mode-required-dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #eaecf0;
}

.order-mode-required-dialog__title {
  font-size: 18px;
  line-height: 24px;
  color: #344554;
}

.order-mode-required-dialog__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: transparent;
  color: #858c98;
  cursor: pointer;
  font-size: 16px;
}

.order-mode-required-dialog__body {
  padding: 40px 30px;
}

.order-mode-required-dialog__main {
  margin: 0;
  font-size: 18px;
  line-height: 24px;
  color: #000000;
}

.order-mode-required-dialog__sub {
  margin: 10px 0 0;
  font-size: 16px;
  line-height: 20px;
  color: #858c98;
}

.order-mode-required-dialog__footer {
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 20px;
  padding: 0 30px 40px;
  box-sizing: border-box;
}

.order-mode-required-dialog__btn {
  flex: 1;
  min-width: 0;
  min-height: 46px;
  height: auto;
  padding: 10px 15px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #ffffff;
  cursor: pointer;
  white-space: normal;
  word-break: break-word;
  text-align: center;
}

.order-mode-required-dialog__btn--standard {
  background: #009246;
}

.order-mode-required-dialog__btn--dap {
  background: #78b719;
}
</style>
